import React, { FC } from 'react';
import IconDinero from '../../../Icons/IconDinero';
import IconTarjeta from '../../../Icons/IconTarjeta';
import IconPorcentaje from '../../../Icons/IconPorcentaje';
// import { useTranslation } from 'react-i18next';
// import useAPIError from '../../hooks/useAPIError';
// import { useAuthStore } from '../../store/AuthContext';
// import { useAppStore } from '../../store/AppContext';
import clubOro from '../../../assets/images/club-oro.png';

const TitularOroCaprabo: FC = () => {
  // const { t } = useTranslation();
  // const dataUser = useAuthStore();
  // const dataApp = useAppStore();
  // const { addError, addErrorBack } = useAPIError();

  // useEffect(() => {
  //   if (dataUser.user.token !== '') retrieveSaldo();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [i18n.language]);
  return (
    <>
      <section className="header-tarjetas tarjetas">
        <div className="container">
          <div className="header-tarjetas__content">
            <h1 className="header-tarjetas__title">Tarjetas</h1>
            <div className="bloque-etiquetas">
              <span className="etiqueta">Eroski Club</span> +{' '}
              <span className="etiqueta oro">Tarjeta oro</span>
            </div>
            <p>
              Tu número de socio <strong>601547029</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="o-section--giant__top u-padding-bottom-hero section--background-color tarjetas">
        <div className="container-inner">
          <div className="grupo-tarjetas">
            <div className="img-tarjeta">
              <img src={clubOro} alt="Tarjeta Eroski Club yTarjeta oro" />
            </div>
          </div>

          <div className="tarjeta__content">
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">Club Caprabo</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-space-between">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿No has recibido tu tarjeta de socio?
                </p>
                <p>
                  Puedes{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    imprimir tutarjeta temporal
                  </a>
                </p>
              </div>

              <div className="bloque-socio">
                <form method="post">
                  <fieldset>
                    <legend className="title__medium u-margin-bottom-small">
                      ¿Necesitas otra tarjeta para ti o tu familia?
                    </legend>
                    <ul className="u-margin-bottom-medium">
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            id="perdida"
                            value="perdida"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="perdida" className="control-label">
                            Si, la he perdido
                          </label>
                        </div>
                      </li>
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            id="estropeada"
                            value="estropeada"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="estropeada" className="control-label">
                            Si, la tengo muy estropeada
                          </label>
                        </div>
                      </li>
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            value="familia"
                            id="familia"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="familia" className="control-label">
                            Si, la quiero para un familiar
                          </label>
                        </div>
                      </li>
                    </ul>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a href="" className="link link-demi">
                      Solicitar
                    </a>
                  </fieldset>
                </form>
              </div>
            </div>
            <div className="divider small" />

            <h2 className="bloque-datos__title">
              <span className="divider__square brand-gold-color" />
              <span className="u-margin-right">Tarjeta Oro</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-space-between">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿Quieres cambiar de cuota?
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-oro link-demi">
                    Cambiar
                  </a>
                </p>
              </div>

              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿Quiéres hacer otras gestiones
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-oro link-demi">
                    Gestionar
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="o-section--superhero tarjetas">
        <div className="container">
          <h2 className="titulo-pagina u-text-brand u-text-center">
            Ahorra más con estas tarjetas
          </h2>
          <div className="bloque-tarjeta bloque-tarjeta__club">
            <p className="etiqueta">Tarjeta de credito</p>
            <div className="bloque-tarjeta__contenido">
              <div className="img">
                <img
                  src="../../assets/images/img-tarjeta.png"
                  alt="Imagen tarjeta Club pasando de manos"
                />
              </div>

              <div className="bloque-tarjeta__content">
                <p className="title__medium u-margin-bottom-small">
                  Ahorra aún más con la nueva tarjeta de crédito gratuita
                </p>
                <p className="u-margin-bottom-small">
                  En alimentación, hogar, gasolina, cuando hagas un viaje.
                  ¡hasta en las gafas!
                </p>

                <ul className="lista-ventajas">
                  <li className="lista-ventajas__item">
                    <IconDinero />
                    <span>Dinero en efectivo y sin comisiones</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <IconPorcentaje classCss="fill-rojo-eroski" />

                    <span>1% de ahorro en tus compras fuera de EROSKI(*)</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <IconTarjeta />
                    <span>Una tarjeta con todos tus ventajas(*)</span>
                  </li>
                </ul>

                <div className="botonera">
                  <button type="button" className="btn btn-primary">
                    Solicitar
                  </button>
                </div>
              </div>
            </div>
            <p className="legal">
              *EROSKI te devuelve automáticamente este importe el día 7 de cada
              mes en tu tarjeta EROSKI club asociada, cuyo número figura bajo el
              código de barras de la trasera de tu tarjeta. Quedan excluidas las
              compras en Hipermercados y sus gasolineras, Supermercados y sus
              gasolineras, tiendas de Alimentación, usos relacionados con el
              juego o apuestas y extracciones y disposiciones de efectivo, al no
              ser operaciones de compra de bienes o servicios. El importe a
              devolver se calcula sobre las compras netas (restados abonos y
              devoluciones) según tipología de actividad comunicada por el
              establecimiento vendedor.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default TitularOroCaprabo;
